module.exports = __webpack_public_path__ + "img/icon-yoga.e154bca8.svg";